<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right">
        <button
          type="button"
          pButton
          (click)="export()"
          class="ui-button-success csv-export">
          <i class="mdl2-excel"></i> Export to CSV
          @if (excelLoading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>

    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="engagementList"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          scrollHeight="550px"
          dataKey="m365eventId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          (onPage)="pageChange($event)"
          (onFilter)="applyFilter($event)"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr class="row">
              <th [pSortableColumn]="'engagementKey'" class="colsmall">
                Engagement ID<p-sortIcon [field]="'engagementKey'"></p-sortIcon>
              </th>
              <th class="colsmall">Preview</th>
              <th [pSortableColumn]="'engagementSubType'" class="colmedium">
                Workshop Type<p-sortIcon
                  [field]="'engagementSubType'"></p-sortIcon>
              </th>
              @if (isPoeDoc) {
                <th [pSortableColumn]="'taskOwner'" class="colsmall">
                  Task Owner<p-sortIcon [field]="'taskOwner'"></p-sortIcon>
                </th>
              }
              <th
                [pSortableColumn]="'partnerInputParnterName'"
                class="colmedium">
                Partner Org<p-sortIcon
                  [field]="'partnerInputParnterName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'partnerInputCustomerName'"
                class="colmedium">
                Customer Org<p-sortIcon
                  [field]="'partnerInputCustomerName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'partnerInputCustomerCountry'"
                class="colsmall">
                Customer Country
                <p-sortIcon
                  [field]="'partnerInputCustomerCountry'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'fiscalYear'" class="colsmall">
                Fiscal Year
                <p-sortIcon [field]="'fiscalYear'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'l1InternalStatus'" class="colsmall">
                L1InternalStatus<p-sortIcon
                  [field]="'l1InternalStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'status'" class="colsmall">
                L2InternalStatus<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="sortableColumnForUploadedDate"
                class="colsmall">
                Uploaded Date<p-sortIcon
                  [field]="sortableColumnForUploadedDate"></p-sortIcon>
              </th>
            </tr>
            <tr class="row">
              <th class="colsmall"></th>
              <th class="colsmall"></th>
              <th class="dashtable colmedium">
                <input
                  class="workshop-filter"
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'engagementSubType',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['engagementSubType']
                      ? $any(dt.filters['engagementSubType']).value
                      : ''
                  " />
              </th>
              @if (isPoeDoc) {
                <th class="dashtable colsmall">
                  <p-multiSelect
                    [options]="ftaskOwnerDrpdwn"
                    #tak
                    appendTo="body"
                    placeholder="Task Owner"
                    (onChange)="
                      dt.filter($event.value, 'taskOwner', 'in')
                    "></p-multiSelect>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr
              (dblclick)="editRequestDetails(rowData.engagementKey)"
              class="row">
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }}"
                  ><a
                    (click)="editRequestDetails(rowData.engagementKey)"
                    (keydown.enter)="editRequestDetails(rowData.engagementKey)"
                    tabindex="0"
                    class="editlink"
                    >{{ rowData.engagementKey }}</a
                  ></span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.engagementKey
                  }}"
                  ><a
                    class="editlink"
                    (click)="previewFile(rowData.engagementKey)"
                    (keydown.enter)="previewFile(rowData.engagementKey)"
                    tabindex="0"
                    >Preview</a
                  ></span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.engagementSubType
                  }}"
                  >{{ rowData.engagementSubType }}</span
                >
              </td>
              @if (isPoeDoc) {
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.engagementKey }} : {{
                      rowData.taskOwner
                    }}"
                    >{{ rowData.taskOwner }}</span
                  >
                </td>
              }
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputParnterName
                  }}"
                  >{{ rowData.partnerInputParnterName }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputCustomerName
                  }}"
                  >{{ rowData.partnerInputCustomerName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputCustomerCountry
                  }}"
                  >{{ rowData.partnerInputCustomerCountry }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.fiscalYear
                  }}"
                  >{{ rowData.fiscalYear }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.l1InternalStatus
                  }}"
                  >{{ rowData.l1InternalStatus }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{ rowData.status }}"
                  >{{ rowData.status }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    getUploadedDate(rowData)
                  }}"
                  >{{ getUploadedDate(rowData) }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [transitionOptions]="'10ms'"
    [(visible)]="editNav"
    modal="true"
    showEffect="fade"
    [maximizable]="true"
    [style]="{ width: '90vw' }"
    (onHide)="onCloseEditModal()"
    [draggable]="false"
    [resizable]="false">
    <app-edit
      [engagementEditInput]="engagementEditInput"
      #editNavChild
      (refreshPartnerInput)="refresh()"
      (showFullscreen)="onShowFullScreenChanged($event)"
      (closeEditSidebar)="editNav = $event"></app-edit>
  </p-dialog>
}

@if (canShowPreviewModel) {
  <app-engagement-preview
    (reLoadList)="refresh()"
    [engagementPreviewInput]="engagementPreviewInput"
    (closePreviewModal)="closePreview()"></app-engagement-preview>
}
